export const onkeydownInputQuantity = (event) => {
    let checkIfNotNum = false;
    if (event.which != 8 && event.which != 0 && (event.which < 48 || event.which > 57) && (event.which < 96 || event.which > 105)) {
        checkIfNotNum = true;
    }
    return checkIfNotNum && event.preventDefault();
};